import { render, staticRenderFns } from "./MonthlyTaxPublic.vue?vue&type=template&id=0ecdde6d"
import script from "./MonthlyTaxPublic.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports